module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/store_images/5_7a867b2dc19585b8a1fb357d2d0bcb66.png";